import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';

const { FiMail } = FiIcons;

function Contact() {
  return (
    <section className="contact-section" id="contact">
      <Reveal className="contact-inner">
        <p className="eyebrow">Open inbox</p>
        <h2>Reporter, podcast host, or just curious how a directory ends up inside an AI answer?</h2>
        <p>Email me directly. I read everything myself, no assistant filtering the inbox.</p>
        <a className="email-button" href="mailto:perry@perrydasilva.com">
          <SafeIcon icon={FiMail} />
          perry@perrydasilva.com
        </a>
        <div className="contact-links">
          <a href="https://otsoco.com" target="_blank" rel="noreferrer">otsoco.com</a>
          <a href="https://instagram.com/laurellocalbusiness" target="_blank" rel="noreferrer">@laurellocalbusiness</a>
          <span>Laurel, Maryland</span>
        </div>
      </Reveal>
    </section>
  );
}

export default Contact;